import React from 'react'

export default function Dashboard() {
  return (
    <div className='flex justify-center items-center text-black text-4xl h-full mt-80'>
      Welcome to Ecomzy!!
    </div>
  )
}